export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/KP-f55eb5521e382993822aa64a2b1e03f2.png";